import i18n from '@/plugins/i18n';

export const k8mClusterGraphs = () => ({
  //TODO: Update the graph colors and metric names while integrating with the backend
  node: {
    lineCharts: [
      {
        metricName: 'k8s_node_v2_cpu_usage',
        valueColumn: 'value',
        headers: [
          {
            label: i18n.global.t('k8.nodesCap'),
            width: '60%',
            key: 'label',
            sortable: true,
            dataType: 'string',
          },
          {
            label: i18n.global.t('k8.avg'),
            width: '20%',
            key: 'avg',
            sortable: true,
            dataType: 'number',
          },
          {
            label: i18n.global.t('k8.max'),
            width: '20%',
            key: 'max',
            sortable: true,
            dataType: 'number',
          },
        ],
        formula: (value) => value.toFixed(3),
        title: i18n.global.t('k8.cpuUsage'),
        graphTitles: {
          x: i18n.global.t('k8.time'),
          y: i18n.global.t('k8.percentage'),
        },
        isMultiLineSeriesTooltip: true,
      },
      {
        metricName: 'k8s_node_v2_memory_usage',
        valueColumn: 'value',
        headers: [
          {
            label: i18n.global.t('k8.nodesCap'),
            width: '60%',
            key: 'label',
            sortable: true,
            dataType: 'string',
          },
          {
            label: i18n.global.t('k8.avg'),
            width: '20%',
            key: 'avg',
            sortable: true,
            dataType: 'number',
          },
          {
            label: i18n.global.t('k8.max'),
            width: '20%',
            key: 'max',
            sortable: true,
            dataType: 'number',
          },
        ],
        title: i18n.global.t('k8.memoryUsage'),
        formula: (value) => value.toFixed(3),
        graphTitles: {
          x: i18n.global.t('k8.time'),
          y: i18n.global.t('k8.percentage'),
        },
        isMultiLineSeriesTooltip: true,
      },
      {
        metricName: 'k8s_node_v2_ephemeral_storage_allocatable',
        valueColumn: 'value',
        headers: [
          {
            label: i18n.global.t('k8.nodesCap'),
            width: '60%',
            key: 'label',
            sortable: true,
            dataType: 'string',
          },
          {
            label: i18n.global.t('k8.avg'),
            width: '20%',
            key: 'avg',
            sortable: true,
            dataType: 'number',
          },
          {
            label: i18n.global.t('k8.max'),
            width: '20%',
            key: 'max',
            sortable: true,
            dataType: 'number',
          },
        ],
        title: i18n.global.t('k8.storageUsage'),
        formula: (value) => (value / 1048576).toFixed(3),
        graphTitles: {
          x: i18n.global.t('k8.time'),
          y: i18n.global.t('k8.mb'),
        },
        isMultiLineSeriesTooltip: true,
      },
      {
        metricName: 'k8s_node_v2_fs_usage',
        valueColumn: 'value',
        headers: [
          {
            label: i18n.global.t('k8.nodesCap'),
            width: '60%',
            key: 'label',
            sortable: true,
            dataType: 'string',
          },
          {
            label: i18n.global.t('k8.avg'),
            width: '20%',
            key: 'avg',
            sortable: true,
            dataType: 'number',
          },
          {
            label: i18n.global.t('k8.max'),
            width: '20%',
            key: 'max',
            sortable: true,
            dataType: 'number',
          },
        ],
        title: i18n.global.t('k8.volUsage'),
        formula: (value) => value.toFixed(3),
        graphTitles: {
          x: i18n.global.t('k8.time'),
          y: i18n.global.t('k8.percentage'),
        },
        isMultiLineSeriesTooltip: true,
      },
    ],
  },
});
